export default function () {
  if (this.agendas.length < 1) {
    this.loadAgendas()
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/resources/mounted.js